
export const DATE_TIME_TYPE = {
  id: 'DATETIME',
  name: 'DATETIME',
  value: 'DATETIME'
}

export const JSON_EDITOR_HEADER_OPTIONS_TO_REMOVE = [
  // 'sort',
  // 'transformcontents(filter,sort,project)',
  // 'search(ctrl+f)',
  // 'opencontextmenu(clickhere,rightclickontheselection,orusethecontextmenubuttonorctrl+q)'
]

export const JSON_EDITOR_INDENTATION = 2
export const USER_GROUP_KEY_TYPES = {
  VIRTUAL_MANAGER: 'VIRTUAL_MANAGER'
}

// export const LOCAL_STORAGE_KEY_TYPES = {
//   SELECTED_MENU_OPTION: 'SELECTED_MENU_OPTION'
// }

// lot of select operations depends on this key so keeping as variable
export const ADD_VAM_ASSET_TYPE_DROPDOWN_KEY_TYPE = 'title'

export const VIRTUAL_ASSET_ROUTE_TYPE = {
  route: 'virtual-module'
}

export const SPECIAL_CHARACTER_REGEX = /^[a-zA-Z0-9 ]*$/
export const RICH_TEXT_TYPE = {
  name: 'RICHTEXT',
  value: 'RICHTEXT'
}

// in app manager id and name is used
export const FILE_TYPE = {
  name: 'FILE',
  value: 'FILE',
  id: 'FILE'
}

export const JASON_EDITOR_OPTIONS_TO_REMOVE = ['Extract', 'Sort', 'Transform', 'Cut', 'Copy', 'Paste']

// this should match with id of folder types in response
// export const UPLOAD_OPTION_TYPES = {
//   LOTTIE: 'lottie',
//   PDF: 'pdf',
//   JSON: 'json',
//   SVG: 'svg',
//   ZIP: 'zip'
// }

export const IMAGE_UPLOAD_MODES = {
  // for checking if component is used from files tag in content bank
  FILES_MODE: 'FILES_MODE'
}

export const JASON_EDITOR_USED_FOR_TYPES = {
  JSON_EDITOR_FOR_PAGES: 'JSON_EDITOR_FOR_PAGES',
  JSON_EDITOR_FOR_SINGLE_CONFIG_TYPE: 'JSON_EDITOR_FOR_SINGLE_CONFIG_TYPE',
  JSON_EDITOR_FOR_LIST_CONFIG_TYPE: 'JSON_EDITOR_FOR_LIST_CONFIG_TYPE',
  JSON_EDITOR_FOR_SETTING_WIDGET: 'JSON_EDITOR_FOR_SETTING_WIDGET'
}

export const DATE_FORMAT = 'DD-MM-YYYY hh:mm:ss a'

export const CUSTOMER_DETAILS_TABS_TYPE = {
  'EMAIL_DETAILS': 'EMAIL_DETAILS'
}

export const CUSTOM_AUDIT_VALUE_KEYS = {
  NOTIFICATIONS: 'Notifications',
  EMAIL_CONTENTS: 'Email Contents',
  EVENTS: 'Events'
}

// for reusing image upload modal in asset manager
export const IMAGE_MODAL_TYPES = {
  ASSET_FILE_UPLOAD_MODE: 'ASSET_FILE_UPLOAD_MODE',
  IMAGE_UPLOAD_MODE: 'IMAGE_UPLOAD_MODE'
}

export const ACTIVE_VERSION_DROPPABLE_ID = '#ACTIVE_BUCKET_VERSION_(APPENDED_TO_ID_OF_VERSION)_'
export const VERSION_DROPPABLE_ID = '#BUCKET_VERSION_(APPENDED_TO_ID_OF_VERSION)_'
// used for both active and version
export const VERSION_DRAGGABLE_ID = '#DRAGGABLE_(APPENDED_TO_ID_OF_BUCKET_ITEM)_'

export const BUCKET_MANAGER_DARG_ACTION_TYPES = {
  BUCKET_TO_VERSION: 'BUCKET_TO_VERSION',
  BUCKET_TO_ACTIVE_VERSION: 'BUCKET_TO_ACTIVE_VERSION',
  ACTIVE_VERSION_TO_VERSION: 'ACTIVE_VERSION_TO_VERSION',
  ACTIVE_VERSION_TO_ACTIVE_VERSION: 'ACTIVE_VERSION_TO_ACTIVE_VERSION',
  ACTIVE_VERSION_TO_BUCKET: 'ACTIVE_VERSION_TO_BUCKET',
  VERSION_TO_VERSION: 'VERSION_TO_VERSION',
  VERSION_TO_ACTIVE_VERSION: 'VERSION_TO_ACTIVE_VERSION',
  VERSION_TO_BUCKET: 'VERSION_TO_BUCKET',
  BUCKET_SIDEBAR_ASSETS_TO_ACTIVE_VERSION: 'BUCKET_SIDEBAR_ASSETS_TO_ACTIVE_VERSION',
  BUCKET_SIDEBAR_ASSETS_TO_VERSION: 'BUCKET_SIDEBAR_ASSETS_TO_VERSION'
}

export const BUCKET_VERSION_MODAL_TYPES = {
  CREATE_BUCKET_VERSION_MODAL: 'CREATE_BUCKET_VERSION_MODAL',
  UPDATE_BUCKET_VERSION_MODAL: 'UPDATE_BUCKET_VERSION_MODAL'
}
